import { Controller } from 'stimulus'

export default class SnowParticlesController extends Controller {
  private config: object = {
    particles: {
      number: { value: 200, density: { enable: !0, value_area: 800 } },
      color: { value: '#fff' },
      shape: {
        type: 'circle',
        stroke: { width: 0, color: '#000000' },
        polygon: { nb_sides: 10 },
      },
      opacity: {
        value: 0.5,
        random: !0,
        anim: {
          enable: !1,
          speed: 1,
          opacity_min: 0.1,
          sync: !1,
        },
      },
      size: {
        value: 5.945738208161363,
        random: !0,
        anim: {
          enable: !1,
          speed: 40,
          size_min: 0.1,
          sync: !1,
        },
      },
      line_linked: {
        enable: !1,
        distance: 500,
        color: '#ffffff',
        opacity: 0.4,
        width: 2,
      },
      move: {
        enable: !0,
        speed: 1.5,
        direction: 'bottom',
        random: !1,
        straight: !1,
        out_mode: 'out',
        bounce: !1,
        attract: { enable: !1, rotateX: 600, rotateY: 1200 },
      },
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: { enable: !1, mode: 'repulse' },
        onclick: { enable: !1, mode: 'repulse' },
        resize: !0,
      },
      modes: {
        grab: { distance: 400, line_linked: { opacity: 0.5 } },
        bubble: {
          distance: 400,
          size: 4,
          duration: 0.3,
          opacity: 1,
          speed: 3,
        },
        repulse: { distance: 200, duration: 0.4 },
        push: { particles_nb: 4 },
        remove: { particles_nb: 2 },
      },
    },
    retina_detect: !0,
  }

  connect() {
    import(/* webpackPrefetch: true */ 'particles.js').then(() => {
      ;(window as any).particlesJS(this.element.getAttribute('id'), this.config)
    })
  }
}
